<template>
  <div>
    <nav aria-label="breadcrumb" class="content-block">
      <ol class="breadcrumb">
        <li class="breadcrumb-item">
          <a href="#/simpeg-dashboard">Dashboard</a>
        </li>
        <li class="breadcrumb-item">
          <a href="#/gaji-periode">Daftar Periode Penggajian</a>
        </li>

        <li class="breadcrumb-item active" aria-current="page">
          Daftar Skema Penggajian
        </li>
      </ol>
    </nav>

    <div class="content-block">
      <h5>
        Daftar Skema Penggajian
        <span>
          <DxButton
            icon="refresh"
            text="Refresh"
            @click="load"
            styling-mode="outlined"
            type="default"
          />
        </span>
      </h5>
    </div>

    <dx-popup
      :visible="loadingVisible"
      title="Loading..."
      :drag-enabled="false"
      :hide-on-outside-click="false"
      width="300"
      :height="130"
    >
      <div class="d-flex justify-content-center">
        <div
          class="spinner-border"
          style="width: 3rem; height: 3rem"
          role="status"
        ></div>
      </div>
    </dx-popup>

    <div class="content-block" v-if="selectedGajiSkema">
      <div class="dx-card responsive-paddings">
        <div class="left">
          <h5>Skema Penggajian</h5>
          <DxList
            :data-source="dataSourceGajiSkema"
            :search-enabled="true"
            :selected-item-keys="[selectedGajiSkema.id]"
            class="list"
            selection-mode="single"
            @selection-changed="
              listSelectionChanged('selectedGajiSkema', $event)
            "
          >
            <template #item="{ data }">
              <div>
                <div class="list-item">
                  <div class="name">{{ data.nama }}</div>
                  <div class="description">
                    Tgl aktif:
                    {{ commonFunction.formatDateIndonesia(data.tgl_aktif) }}
                  </div>
                </div>
              </div>
            </template>
          </DxList>
        </div>
        <div class="right" v-if="selectedGajiSkema">
          <div class="header">
            <div class="name-container">
              <div class="name">
                {{ selectedGajiSkema.nama }}
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col description">
              Tgl aktif:
              {{
                commonFunction.formatDateIndonesia(selectedGajiSkema.tgl_aktif)
              }}
              <br />
              Status Pegawai: {{ selectedGajiSkema.pegawai_status.nama }}
              <br />
              Khusus utk jabatan:
              {{
                selectedGajiSkema.jabatan ? selectedGajiSkema.jabatan.nama : ""
              }}
              <br />
              Skema Gaji Pokok:
              {{
                selectedGajiSkema.gaji_pokok_skema
                  ? selectedGajiSkema.gaji_pokok_skema.nama
                  : ""
              }}
            </div>
            <div class="col description">
              Tunjangan Jabatan:
              {{
                selectedGajiSkema.tun_jabatan
                  ? selectedGajiSkema.tun_jabatan.nama
                  : ""
              }}
              <br />
              Tunjangan Pangan:
              {{
                selectedGajiSkema.tun_pangan
                  ? selectedGajiSkema.tun_pangan.nama
                  : ""
              }}
              <br />
              Tunjangan Air:
              {{
                selectedGajiSkema.tun_air ? selectedGajiSkema.tun_air.nama : ""
              }}
            </div>
          </div>
          <div>
            <!-- {{ selectedGajiSkema.id }} -->
            <RumusListTemplate
              :gajiSkemaId="selectedGajiSkema ? selectedGajiSkema.id : null"
              :heightList="400"
              :gajiSkemaKomponenStore="
                commonFunction.filteredGajiSkemaKomponenStore(
                  gajiSkemaKomponenStore,
                  selectedGajiSkema.id,
                )
              "
            />
          </div>
        </div>
      </div>
    </div>

    <div
      class="content-block"
      v-if="selectedGajiPokok"
      style="padding-top: 80px"
    >
      <div class="dx-card responsive-paddings">
        <div class="left">
          <h5>Skema Gaji Pokok</h5>
          <DxList
            :data-source="dataSourceGajiPokok"
            :search-enabled="true"
            :selected-item-keys="[selectedGajiPokok.id]"
            class="list"
            selection-mode="single"
            @selection-changed="
              listSelectionChanged('selectedGajiPokok', $event)
            "
          >
            <template #item="{ data }">
              <div>
                <div class="list-item">
                  <div class="name">{{ data.nama }}</div>
                  <div class="description">
                    Tgl aktif:
                    {{ commonFunction.formatDateIndonesia(data.tgl_aktif) }}
                  </div>
                </div>
              </div>
            </template>
          </DxList>
        </div>
        <div class="right" v-if="selectedGajiPokok">
          <div class="header">
            <div class="name-container">
              <div class="name">
                {{ selectedGajiPokok.nama }}
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col description">
              Tgl aktif:
              {{
                commonFunction.formatDateIndonesia(selectedGajiPokok.tgl_aktif)
              }}
            </div>
          </div>
          <div>
            <GajiPokokTableTemplate
              :gajiPokokId="selectedGajiPokok.id"
              :heightList="400"
              :gajiPokokSkemaDetailStore="
                commonFunction.filteredGajiPokokSkemaDetailStore(
                  gajiPokokSkemaDetailStore,
                  selectedGajiPokok.id,
                )
              "
            />
          </div>
        </div>
      </div>
    </div>

    <div
      class="content-block"
      v-if="selectedTunJabatan"
      style="padding-top: 80px"
    >
      <div class="dx-card responsive-paddings">
        <div class="left">
          <h5>Skema Tunjangan Jabatan</h5>
          <DxList
            :data-source="dataSourceTunJabatan"
            :search-enabled="true"
            :selected-item-keys="[selectedTunJabatan.id]"
            class="list"
            selection-mode="single"
            @selection-changed="
              listSelectionChanged('selectedTunJabatan', $event)
            "
          >
            <template #item="{ data }">
              <div>
                <div class="list-item">
                  <div class="name">{{ data.nama }}</div>
                  <div class="description">
                    Tgl aktif:
                    {{ commonFunction.formatDateIndonesia(data.tgl_aktif) }}
                  </div>
                </div>
              </div>
            </template>
          </DxList>
        </div>
        <div class="right" v-if="selectedTunJabatan">
          <div class="header">
            <div class="name-container">
              <div class="name">
                {{ selectedTunJabatan.nama }}
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col description">
              Tgl aktif:
              {{
                commonFunction.formatDateIndonesia(selectedTunJabatan.tgl_aktif)
              }}
            </div>
          </div>
          <div>
            <DxList
              ref="dxList"
              :data-source="tunJabatanDetailSource"
              :height="320"
              :search-enabled="true"
              search-mode="contains"
              search-expr="jabatan.nama"
              class="list"
            >
              <template #item="{ data }">
                <div>
                  <strong>{{ data.jabatan.nama }}</strong>
                </div>
                <div>
                  {{ data.jmlFormatted }}
                </div>
              </template>
            </DxList>
          </div>
        </div>
      </div>
    </div>

    <div
      class="content-block"
      v-if="selectedTunPangan"
      style="padding-top: 80px"
    >
      <div class="dx-card responsive-paddings">
        <div class="left">
          <h5>Skema Tunjangan Pangan</h5>
          <DxList
            :data-source="dataSourceTunPangan"
            :search-enabled="true"
            :selected-item-keys="[selectedTunPangan.id]"
            class="list"
            selection-mode="single"
            @selection-changed="
              listSelectionChanged('selectedTunPangan', $event)
            "
          >
            <template #item="{ data }">
              <div>
                <div class="list-item">
                  <div class="name">{{ data.nama }}</div>
                  <div class="description">
                    Tgl aktif:
                    {{ commonFunction.formatDateIndonesia(data.tgl_aktif) }}
                  </div>
                </div>
              </div>
            </template>
          </DxList>
        </div>
        <div class="right" v-if="selectedTunPangan">
          <div class="header">
            <div class="name-container">
              <div class="name">
                {{ selectedTunPangan.nama }}
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col description">
              Tgl aktif:
              {{
                commonFunction.formatDateIndonesia(selectedTunPangan.tgl_aktif)
              }}
            </div>
          </div>
          <div>
            <DxList
              ref="dxList"
              :data-source="tunPanganDetailSource"
              :height="320"
              :search-enabled="false"
              search-mode="contains"
              search-expr="jabatan.nama"
              class="list"
            >
              <template #item="{ data }">
                <div>
                  <strong>
                    {{
                      data.status_tertanggung
                        ? "Tertanggung"
                        : "Tidak Tertanggung"
                    }}
                  </strong>
                </div>
                <div>
                  {{ data.jmlFormatted }}
                </div>
              </template>
            </DxList>
          </div>
        </div>
      </div>
    </div>

    <div class="content-block" v-if="selectedTunAir" style="padding-top: 80px">
      <div class="dx-card responsive-paddings">
        <div class="left">
          <h5>Skema Tunjangan Air</h5>
          <DxList
            :data-source="dataSourceTunAir"
            :search-enabled="true"
            :selected-item-keys="[selectedTunAir.id]"
            class="list"
            selection-mode="single"
            @selection-changed="listSelectionChanged('selectedTunAir', $event)"
          >
            <template #item="{ data }">
              <div>
                <div class="list-item">
                  <div class="name">{{ data.nama }}</div>
                  <div class="description">
                    Tgl aktif:
                    {{ commonFunction.formatDateIndonesia(data.tgl_aktif) }}
                  </div>
                </div>
              </div>
            </template>
          </DxList>
        </div>
        <div class="right" v-if="selectedTunAir">
          <div class="header">
            <div class="name-container">
              <div class="name">
                {{ selectedTunAir.nama }}
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col description">
              Tgl aktif:
              {{ commonFunction.formatDateIndonesia(selectedTunAir.tgl_aktif) }}
            </div>
          </div>
          <div>
            <DxList
              ref="dxList"
              :data-source="tunAirSource"
              :height="320"
              :search-enabled="false"
              search-mode="contains"
              search-expr="nama"
              class="list"
            >
              <template #item="{ data }">
                <div>
                  <strong> Jml </strong>
                </div>
                <div>
                  {{ data.jmlFormatted }}
                </div>
              </template>
            </DxList>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
.left {
  float: left;
  width: 330px;
  height: 470px;
  padding: 20px;
  background: rgba(191, 191, 191, 0.15);
  margin-right: 30px;
}

.right {
  overflow: hidden;
}

.left .list .dx-list-group-header {
  color: #f05b41;
  font-weight: normal;
  font-size: 18px;
}

.left .list .list-item {
  float: left;
}

.left .list .list-item .name {
  font-weight: bold;
}

.right .header {
  height: 70px;
}

.right .header .name-container {
  float: left;
}

.right .header .name {
  font-size: 30px;
  font-weight: bold;
}

.right .header .price-container {
  padding-top: 27px;
}

.right .name-container .type {
  margin-top: 0;
}

.right .tile {
  margin: 0 -12px 0 -12px;
}

.right .tile-image {
  height: 100%;
  width: 100%;
  object-fit: cover;
}

.right .address-asli {
  padding-top: 30px;
  font-size: 18px;
  opacity: 0.7;
}

.right .description {
  padding-top: 20px;
  font-size: 14px;
  opacity: 0.7;
}

.right .description {
  margin: 10px 0;
}

.type {
  margin: 3px 0 5px 0;
  height: 14px;
  background-image: url("data:image/svg+xml;charset=utf8,%3Csvg%20version%3D%221.1%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%20width%3D%2218px%22%20height%3D%2214px%22%20%3E%3Cpolyline%20fill%3D%22%23F05B41%22%20points%3D%227.5%2C0%209.972%2C4.399%2014.999%2C5.348%2011.5%2C9.015%2012.135%2C14%207.5%2C11.866%202.865%2C14%203.5%2C9.015%200.001%2C5.348%205.028%2C4.399%207.5%2C0%20%22%2F%3E%3C%2Fsvg%3E");
  background-size: 18px 14px;
}

.type.gold {
  width: 54px;
}

.type.platinum {
  width: 72px;
}

.type.diamond {
  width: 90px;
}

.price-container {
  float: right;
  padding-top: 13px;
}

.price-container > div {
  display: inline-block;
}

.price-container .price {
  font-size: 25px;
}

.price-container .caption {
  font-size: 11px;
  line-height: 12px;
  padding-left: 6px;
  opacity: 0.7;
}
</style>

<script>
import DxButton from "devextreme-vue/button";
import GajiPokokTableTemplate from "./GajiPokokTableTemplate.vue";
import RumusListTemplate from "./RumusListTemplate.vue";
import * as commonFunction from "@/utils/common-function.js";
import DxTileView from "devextreme-vue/tile-view";
import DxList from "devextreme-vue/list";
import ArrayStore from "devextreme/data/array_store";
import { data } from "./data.js";
import can from "@/haspermission";
import { useCommonStore } from "@/stores/utility/common-store2";
import { useGajiSettingStore } from "@/stores/views/gaji-setting-store";
import { DxPopup } from "devextreme-vue/popup";
/* eslint-disable */

export default {
  components: {
    DxPopup,
    DxTileView,

    DxList,
    ArrayStore,
    RumusListTemplate,
    GajiPokokTableTemplate,
    DxButton,
  },
  setup() {
    const commonStore = useCommonStore();
    const gajiSettingStore = useGajiSettingStore();
    return {
      commonStore,
      commonFunction,
      gajiSettingStore,
    };
  },
  data() {
    return {
      currentHotel: data[0],
      selectedGajiSkema: null,
      selectedGajiPokok: null,
      selectedTunJabatan: null,
      selectedTunPangan: null,
      selectedTunAir: null,
      dataSource: null,
      dataSourceGajiSkema: null,
      dataSourceGajiPokok: null,
      dataSourceTunJabatan: null,
      dataSourceTunAir: null,
      dataSourceTunPangan: null,
      tunAirStore: null,
      tunPanganStore: null,
      tunPanganDetailStore: null,
      tunJabatanStore: null,
      tunJabatanDetailStore: null,
      gajiSkemaStore: null,
      gajiPokokSkemaStore: null,
      gajiPokokSkemaDetailStore: null,
      gajiSkemaKomponenStore: null,
      loadingVisible: false,
    };
  },

  async created() {
    await this.commonStore.preloadStores();
  },

  async mounted() {
    await this.load();
    // await this.commonStore.preloadStores();
  },

  computed: {
    gridHeight() {
      // Calculate grid height based on your requirements
      return "80vh"; // Set the height to fill the viewport vertically
    },
    // rumusSource() {
    //   console.log("rumusSource", this.selectedGajiSkema.id);
    //   return _.filter(this.commonStore.gajiSkemaKomponenStore, (item) => {
    //     return _.get(item, "gaji_skema_id") === this.selectedGajiSkema.id;
    //   });
    // },

    tunJabatanDetailSource() {
      return _.chain(this.tunJabatanDetailStore)
        .filter(
          (item) =>
            _.get(item, "tun_jabatan_id") === this.selectedTunJabatan.id,
        )
        .map((item) => ({
          ...item,
          jmlFormatted: this.commonFunction.formatNumberWithDots(item.jml),
        }))
        .value();
    },

    tunPanganDetailSource() {
      return _.chain(this.tunPanganDetailStore)
        .filter(
          (item) => _.get(item, "tun_pangan_id") === this.selectedTunPangan.id,
        )
        .map((item) => ({
          ...item,
          jmlFormatted: this.commonFunction.formatNumberWithDots(item.jml),
        }))
        .value();
    },

    // tunPanganDetailSource() {
    //   return _.filter(this.tunPanganDetailStore, (item) => {
    //     // item.jml = this.commonFunction.formatNumberWithDots(item.jml);
    //     return _.get(item, "tun_pangan_id") === this.selectedTunPangan.id;
    //   });
    // },

    // tunAirSource2() {
    //   return _.filter(this.tunAirStore, (item) => {
    //     item.jml = this.commonFunction.formatNumberWithDots(item.jml);
    //     return _.get(item, "id") === this.selectedTunAir.id;
    //   });
    // },

    tunAirSource() {
      return _.chain(this.tunAirStore)
        .filter((item) => _.get(item, "id") === this.selectedTunAir.id)
        .map((item) => ({
          ...item,
          jmlFormatted: this.commonFunction.formatNumberWithDots(item.jml),
        }))
        .value();
    },
  },

  methods: {
    async load() {
      this.loadingVisible = true;

      // this.gajiSkemaStore = await this.gajiSettingStore.getGajiSkema();
      // this.gajiPokokSkemaStore =
      //   await this.gajiSettingStore.getGajiPokokSkema();
      // this.tunAirStore = await this.gajiSettingStore.getTunAir();
      // this.tunPanganStore = await this.gajiSettingStore.getTunPangan();
      // this.tunJabatanStore = await this.gajiSettingStore.getTunJabatan();
      // this.tunJabatanDetailStore =
      //   await this.gajiSettingStore.getTunJabatanDetail();
      // this.tunPanganDetailStore =
      //   await this.gajiSettingStore.getTunPanganDetail();

      const [
        gajiSkema,
        gajiPokokSkema,
        gajiPokokSkemaDetail,
        tunAir,
        tunPangan,
        tunJabatan,
        tunJabatanDetail,
        tunPanganDetail,
        gajiSkemaKomponen,
      ] = await Promise.all([
        this.gajiSettingStore.getGajiSkema(),
        this.gajiSettingStore.getGajiPokokSkema(),
        this.gajiSettingStore.getGajiPokokSkemaDetail(),
        this.gajiSettingStore.getTunAir(),
        this.gajiSettingStore.getTunPangan(),
        this.gajiSettingStore.getTunJabatan(),
        this.gajiSettingStore.getTunJabatanDetail(),
        this.gajiSettingStore.getTunPanganDetail(),
        this.gajiSettingStore.getGajiSkemaKomponen(),
      ]);

      this.gajiSkemaStore = gajiSkema;
      this.gajiPokokSkemaStore = gajiPokokSkema;
      this.gajiPokokSkemaDetailStore = gajiPokokSkemaDetail;
      this.tunAirStore = tunAir;
      this.tunPanganStore = tunPangan;
      this.tunJabatanStore = tunJabatan;
      this.tunJabatanDetailStore = tunJabatanDetail;
      this.tunPanganDetailStore = tunPanganDetail;
      this.gajiSkemaKomponenStore = gajiSkemaKomponen;

      this.loadingVisible = false;
      this.selectedGajiSkema = this.gajiSkemaStore[0];
      this.selectedGajiPokok = this.gajiPokokSkemaStore[0];
      this.selectedTunJabatan = this.tunJabatanStore[0];
      this.selectedTunPangan = this.tunPanganStore[0];
      this.selectedTunAir = this.tunAirStore[0];

      this.dataSourceGajiSkema = {
        store: new ArrayStore({
          data: this.gajiSkemaStore,
          key: "id",
        }),
        searchExpr: ["nama"],
      };

      this.dataSourceGajiPokok = {
        store: new ArrayStore({
          data: this.gajiPokokSkemaStore,
          key: "id",
        }),
        searchExpr: ["nama"],
      };

      this.dataSourceTunJabatan = {
        store: new ArrayStore({
          data: this.tunJabatanStore,
          key: "id",
        }),
        searchExpr: ["nama"],
      };

      this.dataSourceTunPangan = {
        store: new ArrayStore({
          data: this.tunPanganStore,
          key: "id",
        }),
        searchExpr: ["nama"],
      };

      this.dataSourceTunAir = {
        store: new ArrayStore({
          data: this.tunAirStore,
          key: "id",
        }),
        searchExpr: ["nama"],
      };

      this.loadingVisible = false;
    },

    listSelectionChanged(flag, e) {
      this.currentHotel = e.addedItems[0];
      this[flag] = e.addedItems[0];
    },
    can,

    refreshDatagrid(gridRef) {
      // this.$refs[gridRef].instance.clearFilter();
      this.$refs[gridRef].instance.getDataSource().reload();
    },
  },
};
</script>
